import {
  BLEND_MODES,
} from 'pixi.js';

import { getRace } from './helper';

import {
  DRAGONS_BASE_URL,
  PARTICLES,
  SIZE_TYPES,
} from './constants';

import {
  loadTextures,
  getSprite,
} from './common';

const dragonsTextures = {
  body: [
    'body_base',
    'body_color',
  ],
  head: [
    'head_base_closed',
    'head_color_closed',
    'head_base_open',
    'head_color_open',
    'head_base_attack',
    'head_color_attack',
    'head_base_defence',
    'head_color_defence',
    'head_base_winner',
    'head_color_winner',
    'attack_mask',
  ],
  eyes: [
    'eyes_base_open',
    'eyes_color_open',
    'eyes_base_closed',
    'eyes_color_closed',
    'eyes_base_attack',
    'eyes_color_attack',
    'eyes_base_defence',
    'eyes_color_defence',
    'eyes_base_winner',
    'eyes_color_winner',
  ],
  horns: [
    'horn_left_base',
    'horn_left_color',
    'horn_right_base',
    'horn_right_color',
  ],
  spike: [
    'spike_body_base',
    'spike_body_color',
    'spike_tail_base',
    'spike_tail_color',
  ],
  wings: [
    'wing_left_base_up',
    'wing_left_color_up',
    'wing_right_base_up',
    'wing_right_color_up',
    'wing_left_base_down',
    'wing_left_color_down',
    'wing_right_base_down',
    'wing_right_color_down',
  ],
  tail: [
    'tail_base',
    'tail_color',
  ],
  arms: [
    'arm_left_base',
    'arm_left_color',
    'arm_right_base',
    'arm_right_color',
  ],
  legs: [
    'leg_left_base',
    'leg_left_color',
    'leg_right_base',
    'leg_right_color',
  ],
  pattern: [
    'pattern_base_body',
    'pattern_base_head',
    'pattern_base_wing_left_up',
    'pattern_base_wing_left_down',
    'pattern_base_wing_right_up',
    'pattern_base_wing_right_down',
    'pattern_base_tail',
    'pattern_base_arm_left',
    'pattern_base_arm_right',
    'pattern_base_leg_left',
    'pattern_base_leg_right',
  ],
};

export function getDragonSprite(name, size = SIZE_TYPES.SMALL_2X) {
  return getSprite(`${DRAGONS_BASE_URL}/${size}/${name}`);
}

export function getDragonSpriteByRace(raceId, typeId, texture, size = SIZE_TYPES.SMALL_2X) {
  const raceType = getRace(raceId).types[typeId];

  return getDragonSprite(`${raceType}/${texture}`, size);
}

export async function loadDragonsPatterns(dragon, size = SIZE_TYPES.SMALL_2X) {
  return loadTextures(Object.entries(dragon).reduce((acc, [geneType, geneValue]) => {
    const raceType = getRace(geneValue.race).types[geneValue.type];

    return [
      ...acc,
      ...dragonsTextures[geneType]
        .map(texture => `${raceType}/${texture}`),
    ];
  }, []), `${DRAGONS_BASE_URL}/${size}`);
}

export function addSprite(
  size,
  colorFilter,
  partRace,
  patternRace,
  partType,
  patternType,
  container,
  base = '',
  color = '',
  pattern = '',
) {
  const baseSprite = getDragonSpriteByRace(partRace, partType, base, size);

  container.addChild(baseSprite);
  baseSprite.filters = [colorFilter];

  if (pattern) {
    const patternSprite = getDragonSpriteByRace(patternRace, patternType, pattern, size);

    container.addChild(patternSprite);
    patternSprite.mask = baseSprite;
    patternSprite.filters = [colorFilter];
    baseSprite.renderable = true;
    patternSprite.blendMode = BLEND_MODES.OVERLAY;
  }

  if (color) {
    const colorSprite = getDragonSpriteByRace(partRace, partType, color, size);

    container.addChild(colorSprite);
  }

  return container;
}

export async function initDragonRenderer(size = SIZE_TYPES.SMALL_2X) {
  return Promise.all([
    loadTextures(PARTICLES, DRAGONS_BASE_URL),
    loadTextures(['wing_mask'], `${DRAGONS_BASE_URL}/${size}`),
    loadTextures(['shadow'], `${DRAGONS_BASE_URL}/${size}`),
  ]);
}
